import config from 'js/app/config';

import { ANNUALLY } from 'bundles/teams-v2/constants/billing';
import { getDefaultLicenseCount } from 'bundles/teams-v2/utils/experimentUtils';

const RESOURCE_ASSETS_URL = config.url.resource_assets;

export const MASTERCARD_ID = 'nYTCtPatEeqrqBIivh7_bQ';
export const VISA_ID = 's02LAPatEeqrqBIivh7_bQ';
export const CAPITAL_ONE_ID = '99lWBt3KEeuNpw7MyAzmlQ';

export const TEAMS_LOGO_URL = RESOURCE_ASSETS_URL + 'teams_landing/nav/C4T_logo_new.svg';

export const TEAMS_CONTACT_SALES_LINK = `${config.url.base}business/learn-more`;

// Note: This function uses preview() to avoid duplicate impressions.
// The impression is generated once in TeamsMainApp component.
export const DEFAULT_QUERY = () => ({
  learnerCount: getDefaultLicenseCount(false), // Use preview, not get
  billingType: ANNUALLY,
});

export const PAGE_TYPE = {
  ACCOUNT: 'account',
  BILLING: 'billing',
} as const;

export type PageTypeValues = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];

export const DONE_GIF_SOURCE = `${config.url.imageProxyRoot}${config.url.resource_assets}teams_v2/Done.gif`;
